import React from 'react';
import { colors } from '../../../../colorVars';
import { Heading4 } from '../../../atomic/text/Text';
import style from './ActivityLogsTable.module.css';
import { ActivityLogsChronological } from './ActivityLogsTableChronological';
import { ActivityLogsTableHeader } from './ActivityLogsTableHeader';
import { ExportLogs } from './ExportLogs';

export const ActivityLogsTable = () => {
  return (
    <div className={style.container}>
      <header className={style.header}>
        <Heading4 color={colors.lightGrey}>Logs</Heading4>
        <ExportLogs />
      </header>
      <div className={style.tableContainer}>
        <table className={style.table}>
          <ActivityLogsTableHeader />
          <ActivityLogsChronological />
        </table>
      </div>
    </div>
  );
};
